"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _QuestionFill = _interopRequireDefault(require("../../icons-react/rebrand/QuestionFill"));
var _Bubble = _interopRequireDefault(require("../Bubble"));
var _tagTypes = require("./utils/tagTypes");
var HotelCardTag = function HotelCardTag(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    type = _ref.type,
    className = _ref.className,
    tooltipText = _ref.tooltipText;
  var tagBody = type ? _tagTypes.TYPES[type] : undefined;
  var tagTooltip = tooltipText || (tagBody === null || tagBody === void 0 ? void 0 : tagBody.tooltipText) || '';
  return /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
    disabled: !tagTooltip,
    text: tagTooltip
  }, /*#__PURE__*/_react["default"].createElement(StyledHotelCardTag, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("span", null, tagBody === null || tagBody === void 0 ? void 0 : tagBody.icon), /*#__PURE__*/_react["default"].createElement("span", null, text || (tagBody === null || tagBody === void 0 ? void 0 : tagBody.text)), tagTooltip && /*#__PURE__*/_react["default"].createElement(StyledQuestionFillIcon, null)));
};
var StyledHotelCardTag = _styledComponents["default"].div.withConfig({
  displayName: "HotelCardTag__StyledHotelCardTag",
  componentId: "sc-1eqasib-0"
})(["color:var(--black);font-size:14px;font-style:normal;font-weight:400;cursor:default;"]);
var StyledQuestionFillIcon = (0, _styledComponents["default"])(_QuestionFill["default"]).withConfig({
  displayName: "HotelCardTag__StyledQuestionFillIcon",
  componentId: "sc-1eqasib-1"
})(["margin-left:4px;height:14px;path{fill:var(--grey2);}"]);
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelCardTag);